import { Address } from '@acorn-portal/shared/src/services/api';

/**
 * Determines whether to display the overnight address as well as the main (proposer) address
 * on quote summary display cards.
 *
 * The overnight address is shown if both addresses exist, the overnight address has
 * at least one non-empty field, and either the first line or postcode differs from
 * the main address.
 *
 * @param overnightAddress - The overnight address to compare
 * @param mainAddress - The main address to compare against
 * @returns {boolean} True if the overnight address should be displayed separately,
 *                    false otherwise
 */
export const shouldShowOvernightAddress = (overnightAddress?: Address, mainAddress?: Address): boolean => {
	if (!overnightAddress || !mainAddress) return false;

	const isOvernightAddressEmpty = Object.values(overnightAddress).every((value) => !value);
	if (isOvernightAddressEmpty) return false;

	// Show overnight address if line1 or postcode are different
	const lineOneMismatch = overnightAddress.line1 && overnightAddress.line1 !== mainAddress?.line1;
	const postcodeMismatch = overnightAddress?.postcode !== mainAddress?.postcode;

	return lineOneMismatch || postcodeMismatch;
};
